module.exports = __webpack_public_path__ + "fonts/douyuFont.4bab8dd2.otf";